import React, { useState, useContext } from 'react';

export type Offset = { slug: string; offset: number };

interface DocsState {
  activeIds: string[];
  setActiveIds: (activeIds: string[]) => void;
  offsets: Offset[];
  setOffsets: (offsets: Offset[]) => void;
}

const initialState: DocsState = {
  activeIds: [],
  setActiveIds: () => { return; },
  offsets: [],
  setOffsets: () => { return; },
};

export const DocsContext = React.createContext<DocsState>(initialState);

interface DocsProviderProps {
  children: React.ReactNode;
}

export function DocsProvider({ children }: DocsProviderProps): React.ReactElement {
  const [activeIds, setActiveIds] = useState(initialState.activeIds);
  const [offsets, setOffsets] = useState(initialState.offsets);

  const docsState: DocsState = {
    activeIds,
    setActiveIds,
    offsets,
    setOffsets,
  };

  return <DocsContext.Provider value={docsState}>{children}</DocsContext.Provider>;
}

export function useDocsContext(): DocsState {
  return useContext(DocsContext);
}
